import { ReactComponent as Add } from './add.svg';
import { ReactComponent as Bold } from './Bold.svg';
import { ReactComponent as Italic } from './Italic.svg';
import { ReactComponent as Strike } from './Strikethrough.svg';
import { ReactComponent as Link } from './link.svg';
import { ReactComponent as Heading } from './Heading.svg';
import { ReactComponent as Quote } from './Quote.svg';
import { ReactComponent as Bullets } from './Bullets.svg';
import { ReactComponent as Numbers } from './Numbers.svg';
import { ReactComponent as Decrease } from './Decrease level.svg';
import { ReactComponent as Increase } from './Increase level.svg';
import { ReactComponent as Undo } from './Undo.svg';
import { ReactComponent as Redo } from './Redo.svg';
import { ReactComponent as Down } from './Down.svg';
import { ReactComponent as Icon } from './icon.svg';
import { ReactComponent as Left } from './Left.svg';
import { ReactComponent as LeftActive } from './LeftActive.svg';
import { ReactComponent as Right } from './Right.svg';
import { ReactComponent as RightActive } from './RightActive.svg';
import { ReactComponent as Swap } from './Swap.svg';
import { ReactComponent as Edit } from './edit.svg';
import { ReactComponent as Delete } from './delete.svg';
import { ReactComponent as DropDownIcon } from './DropDownIcon.svg';
import { ReactComponent as DoubleScrollRight } from './DoubleScrollRight.svg';
import { ReactComponent as DoubleScrollLeft } from './DoubleScrollLeft.svg';
import { ReactComponent as Comment } from './Comment.svg';
import { ReactComponent as Plus } from './plus.svg';
import { ReactComponent as Minus } from './minus.svg';
import { ReactComponent as EmptyTable } from './emptyTable.svg';
import { ReactComponent as Download } from './download.svg';
import { ReactComponent as Upload } from './upload.svg';
import { ReactComponent as SwapDate } from './swapDate.svg';
import { ReactComponent as Calendar } from './Calendar.svg';
import { ReactComponent as Drag } from './drag.svg';
import { ReactComponent as colorChoose } from './colorChoose.svg';
import { ReactComponent as Download2 } from './download_2.svg';
import { ReactComponent as QRImage } from './Rectangle.svg';
import { ReactComponent as Clear } from './clear.svg';
import { ReactComponent as MinusCircle } from './Minus_circle.svg';
import { ReactComponent as TimeIcon } from './time_icon.svg';
import { ReactComponent as Comment2 } from './Comment_2.svg';
import { ReactComponent as QRSample } from './QRSample.svg';
import { ReactComponent as Save } from './Save.svg';
import { ReactComponent as AttachFiles } from './Attach_Files.svg';
import { ReactComponent as ClearTime } from './clearTime.svg';
import { ReactComponent as CheckCircle } from './check-circle.svg';
import { ReactComponent as CloseSquare } from './close-square.svg';
import { ReactComponent as TaskEdit } from './task-edit.svg';
import { ReactComponent as Currency } from './currency.svg';
import { ReactComponent as EyeStudent } from './eye_student.svg';
import { ReactComponent as Visible } from './visible.svg'

const images = {
  add: { src: Add, command: 'add' },
  down: { src: Down, command: 'down' },
  bold: { src: Bold, command: 'bold' },
  italic: { src: Italic, command: 'italic' },
  strike: { src: Strike, command: 'strike' },
  link: { src: Link, command: 'link' },
  heading: { src: Heading, command: 'heading' },
  quote: { src: Quote, command: 'quote' },
  bullets: { src: Bullets, command: 'bulletList' },
  numbers: { src: Numbers, command: 'orderedList' },
  decrease: { src: Decrease, command: 'outdent' },
  increase: { src: Increase, command: 'indent' },
  foreColor: { src: colorChoose, command: 'foreColor' },
  undo: { src: Undo, command: 'undo' },
  redo: { src: Redo, command: 'redo' },
  icon: { src: Icon, command: 'icon' },
  left: { src: Left, command: 'left' },
  right: { src: Right, command: 'right' },
  leftActive: { src: LeftActive, command: 'leftActive' },
  rightActive: { src: RightActive, command: 'rightActive' },
  swap: { src: Swap, command: 'swap' },
  edit: { src: Edit, command: 'edit' },
  delete: { src: Delete, command: 'delete' },
  dropDownIcon: { src: DropDownIcon, command: 'dropDownIcon' },
  doubleScrollRight: { src: DoubleScrollRight, command: 'doubleScrollRight' },
  doubleScrollLeft: { src: DoubleScrollLeft, command: 'doubleScrollLeft' },
  comment: { src: Comment, command: 'comment' },
  plus: { src: Plus, command: 'plus' },
  minus: { src: Minus, command: 'minus' },
  emptyTable: { src: EmptyTable, command: 'emptyTable' },
  download: { src: Download, command: 'download' },
  upload: { src: Upload, command: 'upload' },
  swapDate: { src: SwapDate, command: 'swapDate' },
  calendar: { src: Calendar, command: 'calendar' },
  drag: { src: Drag, command: 'drag' },
  colorChoose: { src: colorChoose, command: 'colorChoose' },
  download2: { src: Download2, command: 'download2' },
  qrImage: { src: QRImage, command: 'qrImage' },
  clear: { src: Clear, command: 'clear' },
  minusCircle: { src: MinusCircle, command: 'minusCircle' },
  timeIcon: { src: TimeIcon, command: 'timeIcon' },
  comment2: { src: Comment2, command: 'comment2' },
  qrSample: { src: QRSample, command: 'qrSample' },
  save: { src: Save, command: 'save' },
  attachFiles: { src: AttachFiles, command: 'attachFiles' },
  clearTime: { src: ClearTime, command: 'clearTime' },
  checkCircle: { src: CheckCircle, command: 'checkCircle' },
  closeSquare: { src: CloseSquare, command: 'closeSquare' },
  taskEdit: { src: TaskEdit, command: 'taskEdit' },
  currency: { src: Currency, command: 'currency' },
  eyeStudent: { src: EyeStudent, command: 'eyeStudent' },
  visible: { src: Visible, command: 'visible' }
};

export const toolbarOptions4 = [images.bold, images.italic, images.foreColor];

export const toolbarOptions6 = [
  images.bold,
  images.italic,
  images.foreColor,
  images.link,
];

export const toolbarOptions1 = [
  images.bold,
  images.italic,
  images.strike,
  images.link,
];

export const toolbarOptions2 = [
  images.heading,
  images.quote,
  images.bullets,
  images.numbers,
  images.decrease,
  images.increase,
];

export const toolbarOptions3 = [images.undo, images.redo];

export const toolbarOptions5 = [images.attachFiles];

export default images;
